import SLATE_NODES from '../../constants/slateNodes';
import getVoidNodesCount from '../clipboard/getVoidNodeCount';
import handleBulletShifting from './handleBulletShifting';
import hasBullet from './hasBullet';
import handleBullet from '../insertBlock';

export default (event, editor, handleKeyboardCommandExec) => {
  const {
    focusBlock,
    focusInline,
    fragment,
    selection: initialSelection,
  } = editor.value;
  const { isExpanded } = initialSelection;
  const selectedBlocks = fragment.nodes.toArray();
  const { citationCount } = getVoidNodesCount(editor, selectedBlocks);
  event.preventDefault();
  const isListItem = hasBullet(editor);
  const { shiftKey } = event;
  if (!isListItem) {
    handleBullet(editor);
    return true;
  }
  if (isListItem && !isExpanded) {
    const isReturn = handleBulletShifting(
      editor,
      shiftKey,
      focusBlock,
      null,
      null,
      null,
      editor.value.document,
    );

    if (isReturn) return true;
  }
  if (isListItem && isExpanded) {
    // if (anchorBlock.key === focusBlock.key) {
    const prevSiblingNewIndices = {};
    const paraBlocks = editor.value.document
      .getLeafBlocksAtRange(editor.value.selection)
      .toArray();

    const initialDoc = editor.value.document;
    let preventDefault = false;
    paraBlocks.some((paraBlock, index) => {
      preventDefault = handleBulletShifting(
        editor,
        shiftKey,
        paraBlock,
        index,
        paraBlocks,
        prevSiblingNewIndices,
        initialDoc,
      );
      return preventDefault;
    });
    return preventDefault;
    // }
    // const [startBlock, endBlock] = isForward
    //   ? [anchorBlock, focusBlock]
    //   : [focusBlock, anchorBlock];
    // editor.moveTo(startBlock.key);
    // let level = findBulletLevel(editor);
    // while (editor.value.focusBlock.key !== endBlock.key) {
    //   if (level >= findBulletLevel(editor)) {
    //     level = findBulletLevel(editor);
    //     handleBulletShifting(editor, shiftKey);
    //   }
    //   editor.moveToStartOfNextBlock();
    // }
    // if (level >= findBulletLevel(editor))
    //   handleBulletShifting(editor, shiftKey);
  }
  if (focusInline) {
    return true;
  }
  if (
    !isListItem &&
    (focusBlock.type === SLATE_NODES.FIGURE_CAPTION ||
      focusBlock.type === SLATE_NODES.PARAGRAPH)
  ) {
    editor.insertText('      ');
    if (citationCount) handleKeyboardCommandExec(editor);
  }

  return false;
};
